<template>
  <div>
    <h3  style="text-align: center;">AUTORIZACIÓN EXPRESA PARA LA CONSULTA A CENTRALES DE INFORMACIÓN FINANCIERA</h3>
    <p>Declaro que la información que he suministrado es verídica y doy mi consentimiento expreso e irrevocable a La Fundación Apoyo o a quien en un futuro sea el acreedor del crédito.</p>
<ol class="list-decimal">
    <li>Consultar en cualquier tiempo en las centrales de información financiera toda la información relevante para conocer mi desempeño como deudor o deudor solidario.</li>
    <li>Reportar a las centrales de información financiera, datos sobre el cumplimiento o incumplimiento de mis obligaciones crediticias, si las hubiere, de tal forma que estas presenten una información veraz, pertinente, completa, actualizada y exacta.</li>
    <li>Reportar la información mencionada a las centrales de información financiera de manera directa, y también, por medio de la Superintendencia Financiera de Colombia o las demás entidades públicas que ejercen funciones de vigilancia y control, con el fin de que estas puedan tratarlas, analizarlas, clasificarlas y luego suministrarlas a dichas centrales.</li>
    <li>Conservar en la Fundación Apoyo y en las centrales de información financiera, las debidas actualizaciones durante el periodo necesario señalado en sus reglamentos y la información indicada en los numerales 2 y 5 de esta autorización.</li>
    <li>Suministrar a las centrales de información financiera datos relativos a mis solicitudes de crédito, así como lo concerniente a mis relaciones comerciales, financieras y en general socioeconómicas que yo haya entregado o que consten en registros públicos, bases de datos públicas o documentos públicos.</li>
    <li>Reportar a las autoridades tributarias, aduaneras o judiciales la información que requieran para cumplir sus funciones de controlar y velar el acatamiento de mis deberes constitucionales y legales.</li>
</ol>
<p>La autorización anterior no me impedirá ejercer mi derecho a corroborar en cualquier tiempo que la información suministrada es veraz, completa, exacta y actualizada, y en caso de que no lo sea, a que se deje constancia de mi desacuerdo, a exigir su rectificación y a que se me informe sobre las correcciones adecuadas. Tampoco liberará a las centrales de información financiera de la obligación de indicarme, cuando yo lo pida quien consultó mi historia de desempeño crediticio durante los seis meses anteriores a mi petición.</p>
<p>La información consultada a la central de información financiera podrá ser utilizada para evaluar los riesgos de concederme un crédito y para verificar por parte de las autoridades públicas competentes, el cumplimiento de mis deberes constitucionales y legales; además, elaborar estadísticas y derivar mediante modelos matemáticos conclusiones de ellas.</p>
<p>La autorización anterior no permite a La Fundación Apoyo, ni a las centrales información financiera divulgar la información mencionada para fines diferentes.</p>
<p>Declaro haber leído cuidadosamente el contenido de estas cláusulas y haberlas comprendido a cabalidad, razón por la cual entiendo sus alcances y sus implicaciones.</p>

  </div>
</template>
<style>
.list-decimal{ 
  padding: 20px;
}
p{
  margin-bottom: 10px !important;
}
.modal-content{
  padding-bottom: 50px !important;
  padding-top: 50px !important;
}
</style>
<script>
export default {
  name: 'aporte_titulo_donacion',
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>